var _rect, _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3, _line4, _path7, _line5, _line6, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoInternet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 178,
    viewBox: "0 0 161 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 18,
    width: 76,
    height: 121,
    rx: 8,
    fill: "#3A3A3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.429 69.084C116.937 69.084 117.424 68.8892 117.814 68.5183C118.575 67.7578 118.575 66.5286 117.814 65.768C105.52 53.481 85.5361 53.481 73.2426 65.768C72.4816 66.5285 72.4816 67.7578 73.2426 68.5183C74.0036 69.2789 75.2335 69.2789 75.9946 68.5183C86.7668 57.7523 104.273 57.7523 115.044 68.5183C115.434 68.8892 115.941 69.084 116.429 69.084H116.429Z",
    fill: "#E72D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 75.0513C110.964 75.0513 111.452 74.8564 111.841 74.4856C112.602 73.7251 112.602 72.4958 111.841 71.7352C102.845 62.7445 88.209 62.7445 79.2114 71.7352C78.4504 72.4958 78.4504 73.725 79.2114 74.4856C79.9723 75.2461 81.2023 75.2461 81.9633 74.4856C89.4374 67.0159 101.596 67.0159 109.071 74.4856C109.461 74.8564 109.969 75.0513 110.456 75.0513H110.456Z",
    fill: "#E72D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.866 80.4555C106.627 79.6949 106.627 78.4657 105.866 77.7051C100.167 72.0097 90.8979 72.0097 85.1801 77.7051C84.4191 78.4657 84.4191 79.6949 85.1801 80.4555C85.57 80.8452 86.0579 81.0212 86.5655 81.0212C87.0731 81.0212 87.561 80.8263 87.9509 80.4555C92.1268 76.282 98.938 76.282 103.114 80.4555C103.875 81.216 105.104 81.216 105.866 80.4555H105.866Z",
    fill: "#E72D38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3672 85.9158C92.3672 87.6712 93.7921 89.0755 95.5288 89.0755C97.2852 89.0755 98.6903 87.6514 98.6903 85.9158C98.6903 84.1801 97.2654 82.756 95.5288 82.756C93.7723 82.7372 92.3672 84.1604 92.3672 85.9158Z",
    fill: "#E72D38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.33 103.741C60.066 99.9378 54.5434 99.9378 52.2802 103.741L30.2073 140.681C27.8857 144.582 30.6952 149.536 35.2432 149.536H79.3664C83.9135 149.536 86.7236 144.582 84.4013 140.681L62.33 103.741ZM57.2942 143.784C55.6545 143.784 54.3277 142.458 54.3277 140.819C54.3277 139.18 55.6546 137.854 57.2942 137.854C58.9338 137.854 60.2607 139.181 60.2607 140.819C60.2607 142.458 58.9338 143.784 57.2942 143.784ZM60.4171 131.341C60.339 132.998 58.9734 134.305 57.2951 134.305C55.6168 134.305 54.2702 132.999 54.1731 131.341L53.139 114.919C53.0222 112.559 54.9152 110.569 57.2762 110.569C59.6372 110.569 61.5303 112.559 61.4135 114.919L60.4171 131.341Z",
    fill: "#E72D38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.821 28.6133H67.2276C62.9151 28.6133 59.4219 32.1045 59.4219 36.4145V97.2278C62.0174 97.7934 64.2618 99.3926 65.6668 101.734L67.2283 104.347L67.2274 44.2168H123.821V126.132H80.2454L87.7393 138.692C89.5541 141.754 89.5937 145.421 87.8372 148.503C87.6225 148.873 87.4078 149.205 87.1544 149.536L123.823 149.537C128.136 149.537 131.629 146.046 131.629 141.736L131.63 36.4158C131.63 32.1049 128.136 28.614 123.824 28.614L123.821 28.6133ZM109.01 38.3656H82.0401C80.9664 38.3656 80.0887 37.4883 80.0887 36.4153C80.0887 35.3423 80.9664 34.465 82.0401 34.465H108.991C110.065 34.465 110.943 35.3423 110.943 36.4153C110.943 37.4874 110.084 38.3656 109.011 38.3656H109.01ZM95.5243 143.685C92.2845 143.685 89.6701 141.072 89.6701 137.835C89.6701 134.597 92.2854 131.984 95.5243 131.984C98.7641 131.984 101.378 134.598 101.378 137.835C101.379 141.073 98.7641 143.685 95.5243 143.685Z",
    fill: "#E72D38"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: -2.5,
    x2: 13.4659,
    y2: -2.5,
    transform: "matrix(-0.708479 0.705732 0.708479 0.705732 153.328 7)",
    stroke: "#E72D38",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: -2.5,
    x2: 13.4659,
    y2: -2.5,
    transform: "matrix(0.708479 0.705732 -0.708479 0.705732 139 7)",
    stroke: "#E72D38",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: -2.5,
    x2: 13.4659,
    y2: -2.5,
    transform: "matrix(-0.708479 0.705732 0.708479 0.705732 29.3281 86)",
    stroke: "#E72D38",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: -2.5,
    x2: 13.4659,
    y2: -2.5,
    transform: "matrix(0.708479 0.705732 -0.708479 0.705732 15 86)",
    stroke: "#E72D38",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5656 13.0094C33.5656 14.9384 31.9931 16.5188 30.0328 16.5188C28.0725 16.5188 26.5 14.9384 26.5 13.0094C26.5 11.0804 28.0725 9.5 30.0328 9.5C31.9931 9.5 33.5656 11.0804 33.5656 13.0094Z",
    stroke: "#E72D38",
    strokeWidth: 5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 139.5,
    y1: 78.5,
    x2: 150.336,
    y2: 78.5,
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 20.5,
    y1: 161.5,
    x2: 37.3689,
    y2: 161.5,
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 139.5,
    y1: 161.5,
    x2: 156.369,
    y2: 161.5,
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 34.5,
    x2: 39.5656,
    y2: 34.5,
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/no_internet.955ea95d72c69dbaf100aa2b9cdf0c70.svg";
export { ForwardRef as ReactComponent };